import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
import FormRow from '@/components/Common/FormRow.vue';
import DriverAutoComplete from '@/components/AutoCompletes/DriverAutoComplete.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccount from '@/types/responses/getAccount';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonDriverRow',
  props: {
    modelValue: {},
    operationOffice: {},
    initialDriverAccountId: {},
    errorMessages: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const driver = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRow, {
    title: _unref(i18n).global.t('pages.gpsTrackerSetting.commonDriver')
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(DriverAutoComplete, {
        key: props.operationOffice?.id,
        modelValue: driver.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((driver).value = $event)),
        "selected-department": null,
        "initial-item-id": props.initialDriverAccountId,
        "operation-offices": props.operationOffice ? [props.operationOffice] : [],
        disabled: !props.operationOffice,
        "error-messages": props.errorMessages,
        class: "autocomplete-width"
      }, null, 8, ["modelValue", "initial-item-id", "operation-offices", "disabled", "error-messages"]))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})